import {
  SET_LIST_CATEGORY_DATA,
  SET_LIST_CATEGORY_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listCategoryData: null,
  listCategoryDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_CATEGORY_DATA:
      return {
        ...state,
        loading: false,
        listCategoryData: action.listCategoryData,
      };

    case SET_LIST_CATEGORY_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listCategoryDataTotal: action.listCategoryDataTotal,
      };

    default:
      return { ...state };
  }
};
